import {DepthService} from "../services/depth/DepthService";

import Components from "./components";
import Directives from "./directives";
import {ForceLiveDepthService} from "../services/depth/ForceLiveDepthService";

const ModuleName = "tfApp.depth";

export default angular.module(ModuleName, [Components(), Directives(ModuleName)])
                      .service(DepthService.id, DepthService)
                      .service(ForceLiveDepthService.id, ForceLiveDepthService)
                      .name;